import React from 'react';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import PropTypes from 'prop-types';
import { dispatchModalItemDeletedRefresh } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { FDDeleteButton, FDBox, FDConfirmationDialog } from '@facet-wealth/design';

export default function DeleteButton({
  dialogProps,
  onDelete,
  onDeleteSuccess,
}) {
  const { displayErrorMessage } = useSnackbarContext();

  const {
    title,
    message,
    confirmLabel,
  } = dialogProps;

  const {
    dialogOpen,
    loading,
    handleSubmit,
    handleOpen,
    handleClose,
  } = useConfirmationDialogState({
    onSubmit: onDelete,
  });

  async function handleConfirm() {
    try {
      const response = await handleSubmit();
      dispatchModalItemDeletedRefresh();
      return onDeleteSuccess(response);
    } catch (err) {
      displayErrorMessage(err, err?.errors || 'Failed to remove item.');
    }

    return undefined;
  }

  return (
    <FDBox alignSelf="center">
      <FDDeleteButton
        onClick={handleOpen}
        loading={loading}
        disabled={loading}
        data-test="delete-button"
      />

      <FDConfirmationDialog
        message={message}
        title={title}
        onConfirm={handleConfirm}
        confirmLabel={confirmLabel}
        onClose={handleClose}
        open={dialogOpen}
        loading={loading}
      />
    </FDBox>
  );
}

DeleteButton.propTypes = {
  dialogProps: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
};

DeleteButton.defaultProps = {
  dialogProps: {},
};
